import { Inject, Injectable, InjectionToken } from "@angular/core";
import { IMetadataAction, RecalculateProperty } from "@tylertech/tyler-api-types";
import { INotificationActionInterface } from "../interfaces";

export const NotificationActionInjector = new InjectionToken<INotificationActionInterface>("NotificationActionInjector");

@Injectable()
export class NotificationService
{
    constructor(@Inject(NotificationActionInjector) private notificationActionInjector: INotificationActionInterface) { }

    ViewNotifications(): void
    {
        const action = <IMetadataAction>{
            RecalculatePropertyOnClose: <RecalculateProperty>{ PropertyToChange: "ViewAll" },
            ServicePath: "NoServiceCall/"
        };

        this.notificationActionInjector.ExecuteAction({$$TypeName: "Api.Core.EF.Notifications.NotificationViewModel"}, action);
    }
}
